import { Button, Space } from 'antd'
import { CreditCardOutlined, GiftOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '@/shared/auth/usePermissions'
import { subscriberGrantsHref, subscriberTransactionsHref } from './subscriberLinks'

interface SubscriberQuickLinksProps {
  subscriberId: string
}

/**
 * Abonent kartasidagi ikki o'tish havolasi (SHARTNOMA-2 §C).
 *
 * ⚠️ HUQUQI YO'Q HAVOLA KO'RSATILMAYDI (JADVAL-QOIDASI §3): bosilib,
 * keyin 403 bermasin. Paketlar ro'yxati `subscriber.read` ostida —
 * kartaning o'zini ko'rgan odamda u bor, shuning uchun u doim chiziladi;
 * tranzaksiyalar esa `ledger.read` ostida va u ALOHIDA huquq.
 */
export function SubscriberQuickLinks({ subscriberId }: SubscriberQuickLinksProps) {
  const { t } = useTranslation()
  const { can } = usePermissions()

  return (
    <Space wrap size="small">
      <Link to={subscriberGrantsHref(subscriberId)}>
        <Button icon={<GiftOutlined />}>{t('subscriber.links.grants')}</Button>
      </Link>
      {can('ledger.read') ? (
        <Link to={subscriberTransactionsHref(subscriberId)}>
          <Button icon={<CreditCardOutlined />}>{t('subscriber.links.transactions')}</Button>
        </Link>
      ) : null}
    </Space>
  )
}
